// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'normalize.css';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import commonConfig from './commonConfig';
import security from './services/security';

const deps = commonConfig(Vue);

Vue.use(security);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n: deps.i18n,
  render: h => h(App),
}).$mount('#app');
